export const collectionSortOptions = [
  "rankingAsc",
  "rankingDesc",
  "titleAsc",
  "titleDesc",
  "artistAsc",
  "artistDesc",
] as const;

export type CollectionSort = (typeof collectionSortOptions)[number];
export type CollectionStatusFilter = "all" | "owned" | "wishlisted" | "missing";

export const collectionStatusOptions = [
  "all",
  "owned",
  "wishlisted",
  "missing",
] as const satisfies readonly CollectionStatusFilter[];
